import React, { ComponentType } from 'react';
import { FastField } from 'formik';

const FieldWrapper =
  <T,>(Component: ComponentType<T>) =>
  (props: Omit<T, 'form' | 'field'>) =>
    <FastField component={Component} {...props} />;

export default FieldWrapper;
